/* REACT */
import React, { Component, createRef } from 'react';
import Cookies from 'universal-cookie';
import { ThemeProvider } from '@material-ui/core/styles';
import TagManager from 'react-gtm-module';

// components
import ComponentForm from '../childrens/componentForm/.mixins';
import ModalEndereco from '../../app/childrens/ui/endereco/.mixins/index';
import PoliticasPrivacidade from "../../app/childrens/ui/politicasPrivacidade/.mixins/index";

// controllers
import Auth from '../../../controllers/auth';
import Config from '../../../controllers/config';

/* CSS */
import theme from './theme';

export default class Login extends Component {

    constructor(props) {
        super(props);
        this.logar = this.logar.bind(this);
        this.child = createRef();
        this.inputRef = createRef();
        this.state = {
            openEndereco: false,
            openPoliticaPrivacidade: false
        };
        this.handleDialogEndereco = this.handleDialogEndereco.bind(this);
        this.handleDialogModalPoliticaPrivacidade = this.handleDialogModalPoliticaPrivacidade.bind(this);
    };
    
    handleDialogEndereco(){
        this.setState({openEndereco: !this.state.openEndereco});

        if (!this.state.openEndereco) {
            TagManager.dataLayer({
                dataLayer: {
                  event: 'event',
                  eventCategory: 'tokstok:fornecedores:login',
                  eventAction: 'clique:botao',
                  eventLabel: 'enderecos:clique-aqui',
                }
            });
        }
    };

    handleDialogModalPoliticaPrivacidade(){
        this.setState({openPoliticaPrivacidade: !this.state.openPoliticaPrivacidade});

        TagManager.dataLayer({
            dataLayer: {
              event: 'event',
              eventCategory: 'tokstok:fornecedores:login',
              eventAction: 'clique:botao',
              eventLabel: 'aviso-de-privacidade',
            }
        });
    };

    async logar(event) {
        event.preventDefault();
        
        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        const form = event.target;
        const data = new FormData(form);
        const obj = {
            codigo: data.get('codigo'),
            senha: data.get('pass')
        };
        
        try {
            const params = JSON.stringify(obj);
            var o_auth = await Auth.login(params,token);
            var j_auth = JSON.parse(o_auth.body);

            if (o_auth.res.statusCode === 200) {
                cookies.set('User-Token', j_auth.acesso, { path: '/' });
                window.location.href = '/';

                TagManager.dataLayer({
                    dataLayer: {
                        event: 'event',
                        eventCategory: 'tokstok:fornecedores:login',
                        eventAction: 'callback',
                        eventLabel: 'sucesso',

                        dimension1: obj.codigo
                    }
                });
            } else {
                if (j_auth && j_auth.message) {
                    throw new Error(j_auth.message);
                } else {
                    throw new Error("Não foi possível efetuar o login!");
                }
            }
        } catch (error) {
            var errorString = "Não foi possível efetuar o login!";
            if (Config.DEBUG === "TRUE")
                errorString = error.message;
            this.child.current.retorno(errorString,'error');

            TagManager.dataLayer({
                dataLayer: {
                  event: 'event',
                  eventCategory: 'tokstok:fornecedores:login',
                  eventAction: 'callback',
                  eventLabel: `erro:${error.message}`,
                  dimension1: obj.codigo
                }
            });
            console.log(error);
        }

    };

    render () {
        return (
            <ThemeProvider theme={theme}>
                <ComponentForm {...this}/>
                <ModalEndereco {...this}/>
                <PoliticasPrivacidade {...this}/>
            </ThemeProvider>
        );
    };
}